/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pagenotfounddescription3Inputs */

const en_pagenotfounddescription3 = /** @type {(inputs: Pagenotfounddescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorry, we couldn't find the page you're looking for.`)
};

const de_pagenotfounddescription3 = /** @type {(inputs: Pagenotfounddescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die gesuchte Seite konnte leider nicht gefunden werden.`)
};

/**
* | output |
* | --- |
* | "Sorry, we couldn't find the page you're looking for." |
*
* @param {Pagenotfounddescription3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const pagenotfounddescription3 = /** @type {((inputs?: Pagenotfounddescription3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pagenotfounddescription3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pagenotfounddescription3(inputs)
	return de_pagenotfounddescription3(inputs)
});
export { pagenotfounddescription3 as "pageNotFoundDescription" }